import FansiKind from '@/ts/enums/global/FansiKind'
import { IconName } from '@/ts/Global'

const PRODUCT_FEATURES: Record<FansiKind, IconName[]> = {
  digital: ['devices', 'sofa', 'star', 'digital_product'],
  fansi_experience: ['devices', 'sofa', 'star'],
  fansi_class: ['devices', 'sofa', 'star'],
  fansi_collection: [
    'clothes_hanger',
    'like',
    'star',
    'fast_delivery',
    'free_delivery',
    'return',
  ],
  fansi_video: ['video_files', 'surprise', 'star'],
  fansi_projects: [],
}

export default PRODUCT_FEATURES
